import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { GroundTruthFilePage } from '@/features/GroundTruthHub/GroundTruthFilePage';
import { ingestedFileIdParams } from '@/features/GroundTruthHub/routeParams';
import { groundTruthRouteBoundaries } from '@/features/GroundTruthHub/GroundTruthNotFound';
import { groundTruthOverviewSearchSchema } from '@/routes/ground-truth/index';

// The overview's filters ride along (with `fromList`) so Next stays in the list the person came from.
const searchSchema = groundTruthOverviewSearchSchema.extend({
    tab: z.string().optional(),
    fromList: z.boolean().optional().catch(undefined),
});

function FilePageRoute() {
    const { ingestedFileId } = Route.useParams();
    return <GroundTruthFilePage ingestedFileId={ingestedFileId} />;
}

export const Route = createFileRoute('/ground-truth/$ingestedFileId/')({
    ...groundTruthRouteBoundaries,
    component: FilePageRoute,
    params: ingestedFileIdParams,
    validateSearch: searchSchema,
});
